import React, { useContext } from 'react';
import { CommentBouldersSector } from '../../constants/types';
import { getDaysDifferenceMessageWithUTC } from '../../constants/helpers';
import DifficultySvg from '../UI/DifficultySvg';
import { GlobalContext } from '../../context/GlobalStateProvider';
import LevelDisplayerDirect from './LevelDisplayerDirect';

const CommentsCard: React.FC<CommentBouldersSector> = ({ boulderId, boulderName, boulderPicture, comment, commentId, createdAt, difficultySvg, firstNameUser, lastNameUser, level, profilePictureUser, sectorName }) => {
    const globalContext = useContext(GlobalContext);
    const { currentGym } = globalContext;

    return (
        <div className='flex flex-row justify-between pb-4 gap-5 min-w-0'>
            <div className='flex flex-col items-start gap-1 min-w-0 flex-1'>
                <div className='flex flex-row gap-2 min-w-0 w-full'>
                    <img className='h-12 w-12 rounded-full object-cover flex-shrink-0' src={profilePictureUser} />
                    <div className='flex flex-col min-w-0'>
                        <div className='bold lower text-grey-600'>
                            {firstNameUser}{' '}{lastNameUser}
                        </div>
                        <div className='regular normal text-grey-700'>
                            {comment}
                        </div>
                    </div>
                </div>
                <div className='bold lower2 text-grey-500 pl-14'>
                    {getDaysDifferenceMessageWithUTC(createdAt)}
                </div>
            </div>
            <div className='flex flex-row gap-6 flex-shrink-0 w-[17%]'>
                <img className='w-20 h-[100px] rounded-sm object-cover flex-shrink-0' src={boulderPicture} />
                <div className='flex flex-col justify-between'>
                    <div className='regular lower2 text-grey-600'>
                        <div>{boulderName}</div>
                        <div>{sectorName}</div>
                    </div>
                    <div className='flex flex-row items-center gap-1'>
                        {currentGym &&
                            <DifficultySvg
                                hasDifficultySystem={currentGym.hasCustomDifficultySystem}
                                svg={difficultySvg}
                                text=''
                            />
                        }
                        <LevelDisplayerDirect
                            level={level}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CommentsCard;
